function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2613",
  "data-name": "Group 2613",
  transform: "translate(-324.496 -45.554)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3712",
  "data-name": "Path 3712",
  d: "M326.136,66.823c.336,3.418,4.867,9.63,4.867,9.63",
  transform: "translate(0 -2.164)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2611",
  "data-name": "Group 2611"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3701",
  "data-name": "Path 3701",
  d: "M363.374,103.382a12.893,12.893,0,0,1-5.534,1.655,12.355,12.355,0,0,1-5.534-1.653l.965-1.284a3.023,3.023,0,0,1,1.513-1.1,2.727,2.727,0,0,1,.608-.11c1.213-.1,1.492.382,2.474.4,1,.015,1.257-.47,2.473-.351a2.7,2.7,0,0,1,.757.174,3.053,3.053,0,0,1,1.291.994Z",
  transform: "translate(-2.926 -2.972)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3703",
  "data-name": "Path 3703",
  d: "M361.265,92.938c-.084.361-.355.441-1.41,1.173a3.867,3.867,0,0,1-3.963,0c-1.055-.733-1.326-.812-1.41-1.173",
  transform: "translate(-3.17 -3.084)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2580",
  "data-name": "Group 2580",
  transform: "translate(336.709 72.687)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3704",
  "data-name": "Path 3704",
  d: "M338.04,78.631a2.689,2.689,0,0,0,3.31-.018,6.443,6.443,0,0,1,2.756-1.41,6.72,6.72,0,0,1,2.171-.114,15.837,15.837,0,0,1,2.855.685c.674.189,1.24.352,1.652.47",
  transform: "translate(-338.04 -75.995)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3705",
  "data-name": "Path 3705",
  d: "M341.945,75.862a2.581,2.581,0,0,0,2.029,1.371",
  transform: "translate(-338.477 -75.862)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2581",
  "data-name": "Group 2581",
  transform: "translate(363.804 69.329)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3706",
  "data-name": "Path 3706",
  d: "M380.786,79.127a3.532,3.532,0,0,1-4.349-.023,8.466,8.466,0,0,0-3.621-1.852,8.828,8.828,0,0,0-2.852-.149,20.8,20.8,0,0,0-3.751.9c-.886.249-1.629.462-2.17.617",
  transform: "translate(-364.043 -75.664)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3707",
  "data-name": "Path 3707",
  d: "M372.2,77.664a3.391,3.391,0,0,0,2.665-1.8",
  transform: "translate(-362.682 -75.862)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3708",
  "data-name": "Path 3708",
  d: "M333.811,91.909a64.046,64.046,0,0,1-2.2-17.145,44.4,44.4,0,0,1,3.048-6.856,36.531,36.531,0,0,1,10.123-12.232,33.042,33.042,0,0,1,6.818-3.953",
  transform: "translate(-0.612 -0.476)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3709",
  "data-name": "Path 3709",
  d: "M372.362,59.065c-3.469-2.228-5.743-7.533-17.246-11.6",
  transform: "translate(-3.241)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3710",
  "data-name": "Path 3710",
  d: "M350.948,73.2a7.02,7.02,0,0,0-4.2-2.239,22.977,22.977,0,0,0-6.578,0",
  transform: "translate(-1.569 -2.6)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3711",
  "data-name": "Path 3711",
  d: "M362.389,76.181s2.784-3.711,9.281-4.95,14.542,0,14.542,0",
  transform: "translate(-4.054 -5.608)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3714",
  "data-name": "Path 3714",
  d: "M374.453,96.755c-1.053,4.328-8.793,20.931-19.23,20.931-8.339,0-23.607-16.154-23.607-36.081",
  transform: "translate(-0.613 -3.817)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_176",
  "data-name": "Ellipse 176",
  cx: 3.282,
  cy: 3.282,
  rx: 3.282,
  ry: 3.282,
  transform: "translate(367.409 72.122)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_177",
  "data-name": "Ellipse 177",
  cx: 2.498,
  cy: 2.498,
  r: 2.498,
  transform: "translate(341.492 74.813)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_568",
  "data-name": "Line 568",
  x2: 4.38,
  transform: "translate(377.777 77.297)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_569",
  "data-name": "Line 569",
  x2: 7.221,
  y2: 3.505,
  transform: "translate(376.032 79.883)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_183",
  "data-name": "Ellipse 183",
  cx: 17.088,
  cy: 17.088,
  r: 17.088,
  transform: "translate(356.961 58.12)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
})));

var SvgWrinklesIcon = function SvgWrinklesIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68.139,
    height: 69.814,
    viewBox: "0 0 68.139 69.814",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWrinklesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wrinkles-icon.082bc277.svg";
export { ForwardRef as ReactComponent };